var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPushTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61948 3.99998L6.62838 3.00888V7.375C6.62838 7.7202 6.34858 8 6.00338 8C5.65823 8 5.37838 7.7202 5.37838 7.375V3.00888L4.38725 4.00001C4.14318 4.24409 3.74745 4.24409 3.50337 4.00001C3.25929 3.75594 3.25929 3.36021 3.50337 3.11613L5.56143 1.05806C5.67863 0.94085 5.83763 0.875 6.00338 0.875C6.16913 0.875 6.32813 0.94085 6.44533 1.05806L8.50338 3.11611C8.74743 3.36018 8.74743 3.75591 8.50338 3.99998C8.25928 4.24407 7.86358 4.24407 7.61948 3.99998Z",
    fill: "#666666",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 7C9.65871 7 9.37891 7.2798 9.37891 7.625V9.375H2.62891V7.625C2.62891 7.2798 2.34909 7 2.00391 7C1.65873 7 1.37891 7.2798 1.37891 7.625V9.5C1.37891 10.1213 1.88259 10.625 2.50391 10.625H9.50391C10.1252 10.625 10.6289 10.1213 10.6289 9.5V7.625C10.6289 7.2798 10.3491 7 10.0039 7Z",
    fill: "#666666",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushTask);
export default __webpack_public_path__ + "static/media/PushTask.fe7cff52db84619cba525fb8199c03f3.svg";
export { ForwardRef as ReactComponent };